<template>
  <div>
    <!-- 搜索表单区域 -->
    <el-form :model="query" label-width="125px" inline size="mini">
      <el-form-item label="类型">
        <el-select v-model="query.type" clearable placeholder="请选择订单类型">
          <el-option label="半周" value="HALF"></el-option>
          <el-option label="周" value="WEEK"></el-option>
          <el-option label="月" value="MONTH"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="商家信息">
        <el-select v-model="query.merchant" clearable filterable placeholder="请选择商家信息">
          <el-option v-for="items in merchantNames" :key="items" :label="items" :value="items"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="创建时间段">
        <el-date-picker
          v-model="query.startCreateTime"
          type="date"
          placeholder="开始日期"
          value-format="yyyy-MM-dd"
          style="width: 150px"
        ></el-date-picker>
        <span style="margin: 0 5px;">至</span>
        <el-date-picker
          v-model="query.endCreateTime"
          type="date"
          placeholder="结束日期"
          value-format="yyyy-MM-dd"
          style="width: 150px"
        ></el-date-picker>
      </el-form-item>
      <el-button type="primary" size="mini" @click="seach">搜索</el-button>
      <el-button type="success" size="mini" @click="excelDetail">明细导出</el-button>
    </el-form>
    <!-- 卡片视图区域 -->
    <el-card>
      <!-- 表格数据展示区域 -->
      <el-table :data="itemList" style="width: 100%" height="650px" border="" stripe>
        <!-- 表格数据展示区域 -->
        <el-table-column prop="name" label="门店" width='120' align="center"></el-table-column>
        <el-table-column prop="detail" label="统计日期" width="180" align="center"></el-table-column>
        <el-table-column label="类型" width="80" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.type === 'HALF'" type="warning">半周</el-tag>
            <el-tag v-else-if="scope.row.type === 'WEEK'" type="warning">周</el-tag>
            <el-tag v-else-if="scope.row.type === 'MONTH'" type="warning">月</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="totalOrder" label="总订单" align="center"></el-table-column>
        <el-table-column prop="roomOrder" label="单包厢订单" align="center"></el-table-column>
        <el-table-column prop="ratioOrder" label="超过%门店" align="center"></el-table-column>
        <el-table-column prop="totalAmount" label="总收入" align="center"></el-table-column>
        <el-table-column prop="roomAmount" label="单包厢收入" align="center"></el-table-column>
        <el-table-column prop="ratioAmount" label="超过%门店" align="center"></el-table-column>
        <el-table-column prop="totalDuration" label="总时长" align="center"></el-table-column>
        <el-table-column prop="roomDuration" label="包厢时长" align="center"></el-table-column>
        <el-table-column prop="ratioDuration" label="超过%门店" align="center"></el-table-column>
        <el-table-column prop="unitPrice" label="平均客单价" align="center"></el-table-column>
        <el-table-column prop="ratioPrice" label="超过%门店" align="center"></el-table-column>
        <el-table-column prop="top30Order" label="排名前30订单" align="center"></el-table-column>
        <el-table-column prop="ratioTop30" label="超过%门店" align="center"></el-table-column>
        <el-table-column prop="wechat" label="微信" align="center"></el-table-column>
        <el-table-column prop="meituan" label="美团" align="center"></el-table-column>
        <el-table-column prop="douyin" label="抖音" align="center"></el-table-column>
        <el-table-column prop="balance" label="余额" align="center"></el-table-column>
        <el-table-column prop="ratioWechat" label="微信占比" align="center"></el-table-column>
        <el-table-column prop="ratioMeituan" label="美团占比" align="center"></el-table-column>
        <el-table-column prop="ratioDouyin" label="抖音占比" align="center"></el-table-column>
        <el-table-column prop="ratioBalance" label="余额占比" align="center"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="130" align="center"></el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="pageSizeChange"
        @current-change="CurrentPageChange"
        :current-page="query.curPage"
        :page-sizes="[5, 10, 15]"
        :page-size="query.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>
  </div>
</template>

<script>
import { merchantStatistics, excelMerchantStatistics } from '@/API/welcome'
import { merchantNameList } from '@/API/merchant'
export default {
  name: 'merchantStatistics',
  data() {
    return {
      query: {
        curPage: 1,
        pageSize: 10,
        type: '',
        merchant: '',
        startCreateTime: '',
        endCreateTime: ''
      },
      // 数据总条数
      total: 0,
      itemList: [],
      merchantNames: [],
      ifCreate: false,
      buttonTxt: '等待生成...'
    }
  },
  created() {
    this.statisticsList()
    this.getSelectData()
  },
  methods: {
    async statisticsList() {
      const { data: res } = await merchantStatistics(this.query)
      if (res.code !== 200) return this.message.error(res.message)
      this.itemList = res.data.entities
      this.total = res.data.totalSize
    },
    async getSelectData() {
      const { data: res } = await merchantNameList({})
      if (res.code !== 200) return this.message.error(res.message)
      this.merchantNames = res.data
    },
    // 重置按钮点击事件
    custody() {
      this.query = {
        curPage: 1,
        pageSize: 10,
        type: '',
        merchant: '',
        startCreateTime: '',
        endCreateTime: ''
      }
      this.statisticsList()
    },
    // 搜索按钮点击事件
    seach() {
      this.query.curPage = 1
      this.statisticsList()
    },
    // 监听pageSize
    pageSizeChange(newSize) {
      this.query.pageSize = newSize
      this.statisticsList()
    },
    // 监听curPage
    CurrentPageChange(newPage) {
      this.query.curPage = newPage
      this.statisticsList()
    },
    // 明细导出
    async excelDetail() {
      const { data: res } = await excelMerchantStatistics(this.query).catch(err => {
        if (err.response) {
          if (err.response.status === 701) {
            return this.$message.error('请筛选后再导出')
          } else if (err.response.status === 702) {
            return this.$message.error('无筛选记录')
          }
        }
        return this.$message.error('系统繁忙，请稍候再试')
      })
      if (!res) {
        return
      }
      let blob = new Blob([res], { type: 'application/vnd.ms-excel' })
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = URL.createObjectURL(blob)
      link.setAttribute('download', '订单统计明细-' + new Date().getTime() + '.xlsx')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}
</script>

<style lang="less" scoped>
.custodyByn {
  margin-left: 38px;
}
.expand {
  .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 33%;
  }
}
.numberingBox {
  cursor: pointer;
}
.el-pagination {
  margin-top: 30px;
}
.payDetails {
  .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
}
</style>
<style lang="less">
.expand label,
.payDetails label {
  color: #99a9bf;
}
</style>
